
import { useState, useEffect, useRef } from "react";
import ProductHeader from "../../Components/ProductsPages/ProductHeader";
import ProductsHeroSection from "../../Components/ProductsPages/ProductsHeroSection";
import ProductFooter from "../../Components/ProductsPages/ProductFooter";
import RequestDemo from "../../Components/ProductsPages/RequestDemo";
import QSleeveImage from "../../Images/videothumbnail.jpg";
import BackgroundGradient from "../../Images/BackgroundGradient.png";
import BackgroundGradientSmall from "../../Images/BackgroundGradientSmall.png";
import VideoComponent from "../../Components/VideoComponent";
import { KeyFeatures } from "../../Components/KeyFeatures";
import { ProductTable } from "../../Components/ProductsPages/ProductTable";
import EPSQKD2 from "../../../src/Images/Boxes/EPSQKD_P2.png";

export default function EPSQKD() {
  const requestDemoRef = useRef(null);
  const architectureRef = useRef(null);

  const [backgroundImage, setBackgroundImage] = useState(``);

  useEffect(() => {
    const updateBackgroundImage = () => {
      if (window.innerWidth < 640) {
        setBackgroundImage(`url(${BackgroundGradientSmall})`);
      } else {
        setBackgroundImage(`url(${BackgroundGradient})`);
      }
    };

    updateBackgroundImage();

    window.addEventListener("resize", updateBackgroundImage);

    return () => window.removeEventListener("resize", updateBackgroundImage);
  }, []);

  const scrollToRequestDemo = () => {
    requestDemoRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToArchitecture = () => {
    architectureRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const keyFeatures = [
    "Compact and Portable Entanglement Generation with Non-linear SPDC process.",
    "Entanglement study with Quantum State Visibility, Quantum State Tomography, Bell Inequality, etc.",
    "High source brightness with High Fidelity.",
    "Experimentation HBT experiment, Heralded Single Photon Source.",
    "Implement BBM92 Entanglement based QKD protocol and more.",
    "QBER and Secure Key Rate calculations.",
    "Quantum Entanglement with Non-linear optical processes, namely SPDC, facilitated by BBO crystal pair.",
    "Entanglement source characterization by Single Channel Count Rate, Coincidence Rate, Quantum State Visibility etc.",
    "Analyse channel efficiency by calculating Detection Error Rate, QBER, S/N ratio, Secure Key Rate.",
    "Entanglement mode characterization and coupling efficiency with varying range of Optical Fibers.",
  ];

  const specifications1 = [
    ["Parameter", "Value"],

    ["Entanglement Mode", "Polarization"],
    ["Crystal", "Paired BBO Type-1"],
    ["Emission Wavelength", "810 nm"],
    ["Pair Generation Rate", "~50 kcps"],
    ["Fidelity", "> 90%"],
    ["Heralding Efficiency", "~ 0.08–0.2"],
    ["Coincidence Counts", "~5%"],
    ["Second Order Correlation Function", "< 0.1"],
    ["|S| Value", "> 2.4"],
    ["Visibility", "> 95%"],
    ["Thermal Operation Range", "10–30 °C"],
    ["Laser Pump Wavelength", "405 nm"],
    ["Laser Pump O/P Power", "Up to 100 mW"],
    ["Dimensions", "550 × 550 × 100 mm"],
    ["Weight", "15 kg"],
  ];



  return (
    <div className="w-full  flex flex-col gap-0 items-center justify-center bg-primary7">
      <div
        className="w-full width flex flex-col gap-0 items-center justify-center bg-contain bg-repeat"
        style={{ backgroundImage: backgroundImage }}
      >
        <ProductHeader scrollToRequestDemo={scrollToRequestDemo} />
        <div className="w-full h-[25rem] ">
          <ProductsHeroSection
            title1="Secure Quantum Communication"
            title2="with Entangled Photon Technology"
            content="Enable real-world quantum cryptography experiments using high-fidelity entangled photons—designed for hands-on exploration of quantum entanglement and secure key distribution via the BBM92 protocol. "
            scrollToArchitecture={scrollToArchitecture}
          />
        </div>

        <div className="w-full bg-primary7 width md:px-10  flex flex-col items-center justify-center pb-10 gap-1">
          <div className="w-[90%] text-center md:text-left text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem] font-RobotoBold text-white leading-tight px-3 ">
            <span className="wordGradient">
              Entanglement-based Quantum Key Distribution Kit
            </span>
          </div>

          <div className="w-[90%] h-full   grid grid-cols-1 xl:grid-cols-2  place-items-start gap-20 p-3">
            <div className="w-full  flex flex-col items-center justify-center  gap-1">
              <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
                The Entangled Photon based Quantum Key Distribution
                Experimentation Kit features an Entangled Photon Source (EPS)
                designed with orthogonally placed Paired-BBO crystal in Type 1
                Non-collinear Configuration which produces high brightness
                entanglement pairs with controllable stability. Pumped by a
                Continuous Wave source at 405nm, it generates down converted
                photons by Spontaneous Parametric Down Conversion (SPDC) at
                810nm. The Signal and Idler are separated by high reflectivity
                mirror pairs and are coupled into fiber couplers integrated with
                collection optics
              </div>
              <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
                Building upon the technical analysis of the performance and
                quality of entangled photons generated, the Kit enables
                experimentation of Quantum Key Distribution setup with BBM92
                protocol. This QKD platform facilitates realising Key
                Distribution, Quantum Bit Error Rate calculations along with
                analysis of signal-to-noise ratio all in one inclusive unit. The
                product is designed as an Integrated experimental QKD system
                facilitating study of quantum entanglement phenomena and its
                application for Quantum Key Distribution.
              </div>

              {/* <div className="w-full px-10 flex items-start justify-start">
                <KeyFeatures features={keyFeatures.slice(0, 7)} />
              </div> */}
            </div>

            <div className="w-full  flex flex-col items-center justify-center  gap-1">
              <div className="w-full  flex flex-col items-start justify-center mt-5">
                <img
                  src={EPSQKD2}
                  alt="EPSQKD1"
                  className="w-full h-full object-contain rounded-lg md:rounded-2xl"
                />
                <p className="w-full lg:max-w-[600px] text-center text-xs italic text-white/70 mt-2">
                  Figure 1: Entanglement-based QKD
                </p>
              </div>
            </div>
          </div>
          <div className="w-[90%] h-full  grid grid-cols-1 xl:grid-cols-2  place-items-start gap-10 ">
            <ProductTable title="Specifications" data={specifications1} />
            <div className="flex flex-col items-center justify-start">
              <KeyFeatures
                title="Key Features"
                features={keyFeatures.slice(0, 7)}
              />
              <KeyFeatures
                title="Experimental Outcomes"
                features={keyFeatures.slice(7, 12)}
              />
            </div>
          </div>
        </div>

        {/* <VideoComponent
          image={QSleeveImage}
          video={"https://thequantum.ai/videos/QSleeveVideo.mp4"}
        /> */}
        <div
          className="w-full bg-primary7  width flex flex-col items-center justify-center gap-2 "
          ref={requestDemoRef}
        >
          <RequestDemo />
        </div>

        <ProductFooter />
      </div>
    </div>
  );
}


